/* eslint-disable */

/** unique or primary key constraints on table "argo.user_role" */
export enum ArgoUserRoleConstraint {
  /** unique or primary key constraint on columns "role_id", "context_id", "user_id" */
  UserRoleContextIdUserIdRoleIdKey = 'user_role_context_id_user_id_role_id_key',
  /** unique or primary key constraint on columns "user_role_id" */
  UserRolePkey = 'user_role_pkey'
}

/** select columns of table "argo.user_role" */
export enum ArgoUserRoleSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "argo.user_role" */
export enum ArgoUserRoleUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

